import { render, staticRenderFns } from "./crudSliders.vue?vue&type=template&id=6baf89ee&"
import script from "./crudSliders.vue?vue&type=script&lang=js&"
export * from "./crudSliders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports